module.exports = __webpack_public_path__ + "img/image (137).d01b27bf.jpg";